// This file is auto-generated by the `update-kc-gen` command. Do not edit it manually.
// Hash: 66d75820bf4784fc2de7d3f6f3bc4140def177a4d24f4c6f0a2ff54b640e933c

/* eslint-disable */
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols
import { lazy, Suspense, type ReactNode } from 'react';

export type ThemeName = 'platform-id-2gis' | 'platform-id-urbi' | 'platform-id';

export const themeNames: ThemeName[] = ['platform-id-2gis', 'platform-id-urbi', 'platform-id'];

export type KcEnvName = never;

export const kcEnvNames: KcEnvName[] = [];

export const kcEnvDefaults: Record<KcEnvName, string> = {};

/**
 * NOTE: Do not import this type except maybe in your entrypoint.
 * If you need to import the KcContext import it either from src/login/KcContext.ts or src/account/KcContext.ts.
 * Depending on the theme type you are working on.
 */
export type KcContext = import('./login/KcContext').KcContext;

declare global {
  interface Window {
    kcContext?: KcContext;
  }
}

export const KcLoginPage = lazy(() => import('./login/KcPage'));

export function KcPage(props: { kcContext: KcContext; fallback?: ReactNode }) {
  const { kcContext, fallback } = props;
  return (
    <Suspense fallback={fallback}>
      {(() => {
        switch (kcContext.themeType) {
          case 'login':
            return <KcLoginPage kcContext={kcContext} />;
        }
      })()}
    </Suspense>
  );
}
